import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class StorageService {
    constructor() {}

    add(key: string, obj: any) {
        return sessionStorage.setItem(key, obj);
    }

    get(key: string) {
        return sessionStorage.getItem(key);
    }

    remove(keys: any) {
        keys.forEach((key: any) => {
            return sessionStorage.removeItem(key);
        });
    }
}
